import { Bleed, Page, useBreakpoints } from '@shopify/polaris'
import ILayout from '@Types/ILayout'

function MainLayout({
  children,
  title,
  titleMetadata,
  subtitle,
  narrowWidth = false,
  pagination = undefined,
  ...props
}: ILayout): JSX.Element {
  const { smOnly } = useBreakpoints()

  return (
    <Bleed marginBlockStart="400">
      <Page
        fullWidth={smOnly}
        narrowWidth={narrowWidth}
        title={title}
        titleMetadata={titleMetadata}
        subtitle={subtitle}
        pagination={pagination}
        {...props}
      >
        {children}
      </Page>
    </Bleed>
  )
}

export default MainLayout
